import { Suspense } from 'react';
import lazyLoadWithRetry from 'v2/core/modules/lazyLoadWithRetry';

const LoaderAnimation = lazyLoadWithRetry(
  () => import('./LoaderAnimation' /* webpackChunkName: "LoaderAnimation" */),
);

export const Loader = () => {
  return (
    <Suspense>
      <LoaderAnimation />
    </Suspense>
  );
};
